export class BatchScheduler {
  constructor(delayMs = 5000) {
    this.delayMs = delayMs
    this.timerId = null
    this.onFlush = null
  }

  setFlushCallback(callback) {
    this.onFlush = callback
  }

  schedule() {
    if (this.timerId) return

    this.timerId = setTimeout(() => {
      this.timerId = null
      if (this.onFlush) this.onFlush()
    }, this.delayMs)
  }

  cancel() {
    if (this.timerId) {
      clearTimeout(this.timerId)
      this.timerId = null
    }
  }

  flush() {
    this.cancel()
    if (this.onFlush) this.onFlush()
  }

  isPending() {
    return this.timerId !== null
  }
}
